import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.859 13.042H.5V11.05h1.572a10.06 10.06 0 012.86-6.108 9.868 9.868 0 016.076-2.908V.5h1.978v3.346c-3.088 0-5.374.728-7.303 3.242l5.306-.043a.992.992 0 110 1.984l-6.428.037c-.616 1.59-.69 2.342-.702 3.976zm18.106-.007a10.087 10.087 0 01-2.822 6.083 9.84 9.84 0 01-6.157 2.94l.006 1.534-1.978.007-.012-3.34c3.13-.013 5.392-.703 7.352-3.255h-5.405a.996.996 0 01-.992-.992c0-.548.45-.992.992-.992h6.527c.61-1.54.678-2.367.671-3.957l3.34-.012.013 1.978-1.535.006zm-13.97-1.978h7.894v1.978H7.994v-1.978z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
